import { render, staticRenderFns } from "./store.vue?vue&type=template&id=4cbc4a8e&scoped=true"
import script from "./store.vue?vue&type=script&lang=js"
export * from "./store.vue?vue&type=script&lang=js"
import style0 from "./store.vue?vue&type=style&index=0&id=4cbc4a8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbc4a8e",
  null
  
)

export default component.exports